require('!style!css!angular-toggle-switch/angular-toggle-switch.css');
require('!style!css!angular-toggle-switch/angular-toggle-switch-bootstrap.css');
require('!style!css!oi.select/dist/select.css');
require('!style!css!ng-tags-input/build/ng-tags-input.css');
require('!style!css!ng-tags-input/build/ng-tags-input.bootstrap.css');
require('!style!css!angular-growl-v2/build/angular-growl.css');
require('!style!css!angular-ui-tree/source/angular-ui-tree.css');
require('!style!css!datetimepicker/dist/DateTimePicker.css');

angular.module('app', [
  'ngAnimate',
  'ui.router',
  'config',
  'base',
  'signup',
  'login',
  'account',
  'admin',
  'unauthorized',
  //'cache.index',
  'services.i18nNotifications',
  'services.httpRequestTracker',
  'filters.rawHtml',
  'filters.stripHtml',
  'security',
  'ui.bootstrap',
  'angular-growl',
  'directives.uiRouterTitle',
  'oi.select',
  'dndLists',
  'ui.bootstrap.datetimepicker',
  'angular-md5'
]);

angular.module('app').config(["$urlRouterProvider", "$locationProvider", "$stateProvider", "$urlMatcherFactoryProvider", function ($urlRouterProvider, $locationProvider, $stateProvider, $urlMatcherFactoryProvider) {
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });
  $urlMatcherFactoryProvider.strictMode(false)

  $stateProvider
    .state('index', {
      url: '/',
      resolve: {
        isAdmin: ["User", "$state", function (User, $state) {
          return User.current(function (user) {
            if (user && user.is_active && user.is_admin) {
              return;
            }

            return $state.go('login');
          }).$promise;
        }]
      }
    })
    .state('logout', {
      url: '/logout',
      views: {
        main: {
          controller: ["security", function (security) {
            security.logout('/login');
          }]
        }
      }
    });
}]);


angular.module('app').config(['growlProvider', function (growlProvider) {
  growlProvider.globalTimeToLive(3000);
  growlProvider.globalPosition('top-center');
}]);


// Node.js Express backend csurf module csrf/xsrf token cookie name
angular.module('app').config(['$httpProvider', 'XSRF_COOKIE_NAME', function ($httpProvider, XSRF_COOKIE_NAME) {
  $httpProvider.defaults.xsrfCookieName = XSRF_COOKIE_NAME;
}]);

angular.module('app').run(["$rootScope", "$state", "User", function ($rootScope, $state, User) {

  $rootScope.$on('$stateChangeError', function (e, toState, toParams, fromState, fromParams, error) {
    if (error === "unauthorized") {
      $state.go("unauthorized");
    }
  });
}]);

angular.module('app').controller('AppCtrl', ["$scope", function ($scope) {

  // $scope.notifications = i18nNotifications;
  //
  // $scope.removeNotification = function (notification) {
  //   i18nNotifications.remove(notification);
  // };
  //
  // $scope.$on('$routeChangeError', function(event, current, previous, rejection){
  //   i18nNotifications.pushForCurrentRoute('errors.route.changeError', 'error', {}, {rejection: rejection});
  // });
}]);
//factory to work with socket.io
angular.module('app').factory('socket', ["$rootScope", function ($rootScope) {
  var socket = io.connect();
  return {
    on: function (eventName, callback) {
      socket.on(eventName, function () {
        var args = arguments;
        $rootScope.$apply(function () {
          callback.apply(socket, args);
        });
      });
    },
    emit: function (eventName, data, callback) {
      socket.emit(eventName, data, function () {
        var args = arguments;
        $rootScope.$apply(function () {
          if (callback) {
            callback.apply(socket, args);
          }
        });
      })
    },
    off: function (eventName) {
      socket.off(eventName);
    }
  };
}]);

/**
 * angular-drag-and-drop-lists v1.4.0
 *
 * Copyright (c) 2014 Marcel Juenemann marcel@juenemann.cc
 * Copyright (c) 2014-2016 Google Inc.
 * https://github.com/marceljuenemann/angular-drag-and-drop-lists
 *
 * License: MIT
 */
angular.module('dndLists', [])


  .directive('dndDraggable', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround',
    function ($parse, $timeout, dndDropEffectWorkaround, dndDragTypeWorkaround) {
      return function (scope, element, attr) {
        // Set the HTML5 draggable attribute on the element
        element.attr("draggable", "true");

        // If the dnd-disable-if attribute is set, we have to watch that
        if (attr.dndDisableIf) {
          scope.$watch(attr.dndDisableIf, function (disabled) {
            element.attr("draggable", !disabled);
          });
        }

        /**
         * When the drag operation is started we have to prepare the dataTransfer object,
         * which is the primary way we communicate with the target element
         */
        element.on('dragstart', function (event) {
          event = event.originalEvent || event;

          // Check whether the element is draggable, since dragstart might be triggered on a child.
          if (element.attr('draggable') == 'false') return true;

          // Serialize the data associated with this element. IE only supports the Text drag type
          event.dataTransfer.setData("Text", angular.toJson(scope.$eval(attr.dndDraggable)));

          // Only allow actions specified in dnd-effect-allowed attribute
          event.dataTransfer.effectAllowed = attr.dndEffectAllowed || "move";

          // Add CSS classes. See documentation above
          element.addClass("dndDragging");
          $timeout(function () {
            element.addClass("dndDraggingSource");
          }, 0);

          // Workarounds for stupid browsers, see description below
          dndDropEffectWorkaround.dropEffect = "none";
          dndDragTypeWorkaround.isDragging = true;

          // Save type of item in global state. Usually, this would go into the dataTransfer
          // typename, but we have to use "Text" there to support IE
          dndDragTypeWorkaround.dragType = attr.dndType ? scope.$eval(attr.dndType) : undefined;

          // Try setting a proper drag image if triggered on a dnd-handle (won't work in IE).
          if (event._dndHandle && event.dataTransfer.setDragImage) {
            event.dataTransfer.setDragImage(element[0], 0, 0);
          }

          // Invoke callback
          $parse(attr.dndDragstart)(scope, {event: event});

          event.stopPropagation();
        });

        element.on('dragend', function (event) {
          event = event.originalEvent || event;

          var dropEffect = dndDropEffectWorkaround.dropEffect;
          scope.$apply(function () {
            switch (dropEffect) {
              case "move":
                $parse(attr.dndMoved)(scope, {event: event});
                break;
              case "copy":
                $parse(attr.dndCopied)(scope, {event: event});
                break;
              case "none":
                $parse(attr.dndCanceled)(scope, {event: event});
                break;
            }
            $parse(attr.dndDragend)(scope, {event: event, dropEffect: dropEffect});
          });

          // Clean up
          element.removeClass("dndDragging");
          $timeout(function () {
            element.removeClass("dndDraggingSource");
          }, 0);
          dndDragTypeWorkaround.isDragging = false;
          event.stopPropagation();
        });
        element.on('click', function (event) {
          if (!attr.dndSelected) return;

          event = event.originalEvent || event;
          scope.$apply(function () {
            $parse(attr.dndSelected)(scope, {event: event});
          });

          // Prevent triggering dndSelected in parent elements.
          event.stopPropagation();
        });


        element.on('selectstart', function () {
          if (this.dragDrop) this.dragDrop();
        });
      };
    }])

  .directive('dndList', ['$parse', '$timeout', 'dndDropEffectWorkaround', 'dndDragTypeWorkaround',
    function ($parse, $timeout, dndDropEffectWorkaround, dndDragTypeWorkaround) {
      return function (scope, element, attr) {
        // While an element is dragged over the list, this placeholder element is inserted
        // at the location where the element would be inserted after dropping
        var placeholder = getPlaceholderElement();
        var placeholderNode = placeholder[0];
        var listNode = element[0];
        placeholder.remove();

        var horizontal = attr.dndHorizontalList && scope.$eval(attr.dndHorizontalList);
        var externalSources = attr.dndExternalSources && scope.$eval(attr.dndExternalSources);

        element.on('dragenter', function (event) {
          event = event.originalEvent || event;
          if (!isDropAllowed(event)) return true;
          event.preventDefault();
        });

        element.on('dragover', function (event) {
          event = event.originalEvent || event;

          if (!isDropAllowed(event)) return true;

          // First of all, make sure that the placeholder is shown
          // This is especially important if the list is empty
          if (placeholderNode.parentNode != listNode) {
            element.append(placeholder);
          }

          if (event.target !== listNode) {
            // Try to find the node direct directly below the list node.
            var listItemNode = event.target;
            while (listItemNode.parentNode !== listNode && listItemNode.parentNode) {
              listItemNode = listItemNode.parentNode;
            }

            if (listItemNode.parentNode === listNode && listItemNode !== placeholderNode) {
              // If the mouse pointer is in the upper half of the child element,
              // we place it before the child element, otherwise below it.
              if (isMouseInFirstHalf(event, listItemNode)) {
                listNode.insertBefore(placeholderNode, listItemNode);
              } else {
                listNode.insertBefore(placeholderNode, listItemNode.nextSibling);
              }
            }
          } else {

            if (isMouseInFirstHalf(event, placeholderNode, true)) {
              // Check if we should move the placeholder element one spot towards the top.
              // Note that display none elements will have offsetTop and offsetHeight set to
              // zero, therefore we need a special check for them.
              while (placeholderNode.previousElementSibling
              && (isMouseInFirstHalf(event, placeholderNode.previousElementSibling, true)
              || placeholderNode.previousElementSibling.offsetHeight === 0)) {
                listNode.insertBefore(placeholderNode, placeholderNode.previousElementSibling);
              }
            } else {
              // Check if we should move the placeholder element one spot towards the bottom
              while (placeholderNode.nextElementSibling && !isMouseInFirstHalf(event, placeholderNode.nextElementSibling, true)) {
                listNode.insertBefore(placeholderNode,
                  placeholderNode.nextElementSibling.nextElementSibling);
              }
            }
          }

          // At this point we invoke the callback, which still can disallow the drop.
          // We can't do this earlier because we want to pass the index of the placeholder.
          if (attr.dndDragover && !invokeCallback(attr.dndDragover, event, getPlaceholderIndex())) {
            return stopDragover();
          }

          element.addClass("dndDragover");
          event.preventDefault();
          event.stopPropagation();
          return false;
        });

        element.on('drop', function (event) {
          event = event.originalEvent || event;

          if (!isDropAllowed(event)) return true;

          // The default behavior in Firefox is to interpret the dropped element as URL and
          // forward to it. We want to prevent that even if our drop is aborted.
          event.preventDefault();

          // Unserialize the data that was serialized in dragstart. According to the HTML5 specs,
          // the "Text" drag type will be converted to text/plain, but IE does not do that.
          var data = event.dataTransfer.getData("Text") || event.dataTransfer.getData("text/plain");
          var transferredObject;
          try {
            transferredObject = JSON.parse(data);
          } catch (e) {
            return stopDragover();
          }

          // Invoke the callback, which can transform the transferredObject and even abort the drop.
          var index = getPlaceholderIndex();
          if (attr.dndDrop) {
            transferredObject = invokeCallback(attr.dndDrop, event, index, transferredObject);
            if (!transferredObject) {
              return stopDragover();
            }
          }
          if (transferredObject !== true) {
            scope.$apply(function () {
              scope.$eval(attr.dndList).splice(index, 0, transferredObject);
            });
          }
          invokeCallback(attr.dndInserted, event, index, transferredObject);
          if (event.dataTransfer.dropEffect === "none") {
            if (event.dataTransfer.effectAllowed === "copy" ||
              event.dataTransfer.effectAllowed === "move") {
              dndDropEffectWorkaround.dropEffect = event.dataTransfer.effectAllowed;
            } else {
              dndDropEffectWorkaround.dropEffect = event.ctrlKey ? "copy" : "move";
            }
          } else {
            dndDropEffectWorkaround.dropEffect = event.dataTransfer.dropEffect;
          }
          stopDragover();
          event.stopPropagation();
          return false;
        });
        element.on('dragleave', function (event) {
          event = event.originalEvent || event;

          element.removeClass("dndDragover");
          $timeout(function () {
            if (!element.hasClass("dndDragover")) {
              placeholder.remove();
            }
          }, 100);
        });
        function isMouseInFirstHalf(event, targetNode, relativeToParent) {
          var mousePointer = horizontal ? (event.offsetX || event.layerX)
            : (event.offsetY || event.layerY);
          var targetSize = horizontal ? targetNode.offsetWidth : targetNode.offsetHeight;
          var targetPosition = horizontal ? targetNode.offsetLeft : targetNode.offsetTop;
          targetPosition = relativeToParent ? targetPosition : 0;
          return mousePointer < targetPosition + targetSize / 2;
        }

        function getPlaceholderElement() {
          var placeholder;
          angular.forEach(element.children(), function (childNode) {
            var child = angular.element(childNode);
            if (child.hasClass('dndPlaceholder')) {
              placeholder = child;
            }
          });
          return placeholder || angular.element("<li class='dndPlaceholder'></li>");
        }

        function getPlaceholderIndex() {
          return Array.prototype.indexOf.call(listNode.children, placeholderNode);
        }

        function isDropAllowed(event) {
          if (!dndDragTypeWorkaround.isDragging && !externalSources) return false;
          if (!hasTextMimetype(event.dataTransfer.types)) return false;
          if (attr.dndAllowedTypes && dndDragTypeWorkaround.isDragging) {
            var allowed = scope.$eval(attr.dndAllowedTypes);
            if (angular.isArray(allowed) && allowed.indexOf(dndDragTypeWorkaround.dragType) === -1) {
              return false;
            }
          }
          if (attr.dndDisableIf && scope.$eval(attr.dndDisableIf)) return false;

          return true;
        }

        function stopDragover() {
          placeholder.remove();
          element.removeClass("dndDragover");
          return true;
        }

        function invokeCallback(expression, event, index, item) {
          return $parse(expression)(scope, {
            event: event,
            index: index,
            item: item || undefined,
            external: !dndDragTypeWorkaround.isDragging,
            type: dndDragTypeWorkaround.isDragging ? dndDragTypeWorkaround.dragType : undefined
          });
        }

        function hasTextMimetype(types) {
          if (!types) return true;
          for (var i = 0; i < types.length; i++) {
            if (types[i] === "Text" || types[i] === "text/plain") return true;
          }

          return false;
        }
      };
    }])
  .directive('dndNodrag', function () {
    return function (scope, element, attr) {
      element.attr("draggable", "true");
      element.on('dragstart', function (event) {
        event = event.originalEvent || event;

        if (!event._dndHandle) {
          if (!(event.dataTransfer.types && event.dataTransfer.types.length)) {
            event.preventDefault();
          }
          event.stopPropagation();
        }
      });

      element.on('dragend', function (event) {
        event = event.originalEvent || event;
        if (!event._dndHandle) {
          event.stopPropagation();
        }
      });
    };
  })


  .directive('dndHandle', function () {
    return function (scope, element, attr) {
      element.attr("draggable", "true");

      element.on('dragstart dragend', function (event) {
        event = event.originalEvent || event;
        event._dndHandle = true;
      });
    };
  })

  .factory('dndDragTypeWorkaround', function () {
    return {}
  })

  .factory('dndDropEffectWorkaround', function () {
    return {}
  });




// WEBPACK FOOTER //
// ./client/src/app/app.js